import { useWebServer } from "../../../../providers";

// The organization service's report endpoints these reports were built on.
// Each takes the report filters as its body.
export const useLegacyReportApi = () => {
  const { sendOrganizationRequest, downloadOrganizationDataWithRawData } = useWebServer();
  const post = (url) => ({ filters }) =>
    sendOrganizationRequest("post")({ url, data: filters || {} });

  return {
    downloadOrganizationDataWithRawData,
    downloadOrganizationDataWithAbundance: post("/organization/data/abundance"),
    downloadOrganizationDataWithWeekly: post("/organization/data/weeklyreport"),
    downloadSpeciesLineChart: post("/organization/data/linechart"),
    // the summary comes back as a JSON string in `body`
    getOrganizationSummaryData: async ({ filters }) =>
      (await post("/organization/summary")({ filters }))?.data?.body,
  };
};
